(function (angular) {
    'use strict';

    angular.module('rcs')
        /**
         *
         */
        .controller('rcsController',
        ['$scope', 'rcsConfig', '$uibModalInstance', 'rcsServices', '$stateParams', 'growlService', '$rootScope',
            function ($scope, rcsConfig, $uibModalInstance, rcsServices, $stateParams, growlService, $rootScope) {
                $scope.rcs = rcsConfig;
                $scope.apiSpaceId =  $stateParams.pickedApiSpaceId;
                
                $scope.cancel = function(){
                    $uibModalInstance.dismiss('cancel');
                };
                
                $scope.close = function(){
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.setDefault = function(agentId){

                    rcsServices.setDefaultAgent($scope.apiSpaceId, agentId)
                        .then(function (result) {
                            growlService.success('Default agent successfully set');
                            $scope.rcs.isDefault = true;
                            $rootScope.$broadcast('defaultAgentSet', agentId);
                        }).catch(function (error) {
                            growlService.danger("Default agent wasn't set due to: " + error.statusText);
                        });
                }
        }]);


})(window.angular);